import { MINUTES } from "@/model/Settings";
import type { Team } from "@/model/session";
import type { AuthUser } from "@/model/user";
import { SimpleCache } from "@/utils/SimpleCache";
import { authAPIUrl } from "@/utils/env/Environment";

import type { ServerAuthUser, ServerAuthUserWithTeams, ServerUserTeam } from "../serverModel";
import { createApiClient, modernInterceptor } from "./api.config";
import { mapUser, mapUserTeams } from "./mapBackendData";
import { addAlmMapping } from "./userAlmMapping";

const emptyListApi = modernInterceptor(createApiClient(authAPIUrl), {
  defaultValue: [],
});

export type UserWithTeams = AuthUser & { teams: Team[] };

export async function searchUsers(query: string): Promise<UserWithTeams[]> {
  const res = await emptyListApi.get<ServerAuthUserWithTeams[]>("/v1/users/search", {
    params: { query },
  });
  return await Promise.all(
    res.data.map((user) => addAlmMapping(mapUser(user), mapUserTeams(user.teams))),
  );
}

const teamUsers = new SimpleCache<AuthUser[]>({ timeout: 60 * MINUTES });

export async function usersInTeam(team: Team): Promise<AuthUser[]> {
  return await teamUsers.loadItem(team.id, () => getUsersInTeam(team));
}

async function getUsersInTeam(team: Team): Promise<AuthUser[]> {
  const res = await emptyListApi.get<ServerAuthUser[]>(`/v1/teams/${team.id}/members`);
  return await Promise.all(res.data.map((user) => addAlmMapping(mapUser(user))));
}

export async function getUserTeams(userId: string): Promise<Team[]> {
  const res = await emptyListApi.get<ServerUserTeam[]>(`/v1/users/${userId}/teams`);
  return mapUserTeams(res.data);
}
